export default __webpack_public_path__ + "static/media/862.3ae56870.png";